import { showAlert } from './lib-2sxc-alerts';
import { disableInputs, enableInputs, getFormValues, sendForm, validateForm } from './lib-2sxc-forms';
import { getRecaptchaToken, requiresRecaptcha } from './lib-2sxc-recaptcha';
import { addTrackingEvent } from './lib-2sxc-tracking';

const debug = true;
//window.debugTurnOn = true;
var winAny = window as any;
winAny.appMobius5 ??= {};
winAny.appMobius5.init ??= initAppMobius5;

function initAppMobius5({ domAttribute } : { domAttribute: string }) {
  if (document.getElementsByTagName('form').length) document.getElementsByTagName('form')[0].setAttribute('novalidate', '');
  if (debug) console.log("Mobius5 loading, debug is enabled");

    const mobiusWrapper = document.querySelectorAll(`[${domAttribute}]`)[0];
    //The promise will be resolved after 5seconds = 5000ms
    if (!mobiusWrapper) return
    let isDone: boolean = false;
    let sendFormResponse = (event:Event, formValues: any) => {
        return new Promise((resolve, reject) => {
            //#region request handling
            let endpoint = (mobiusWrapper as HTMLElement).dataset.webservice // (should be "Form/ProcessForm" or a custom override)
            //let endpoint = "app/auto/api/Enquiry/ProcessForm?workflowId=Default";
            let strJson = JSON.stringify(formValues);
            //endpoint = endpoint.replace('/api/2sxc/','')
            sendForm(formValues, submitButtom, endpoint)
                .then((result: any) => {
                    // error
                    if (result.ok) {
                        // success
                        if (debug) console.log('success', result)
                        submitButtom.setAttribute("disabled", "")

                        showAlert(mobiusWrapper, 'msgOk')
                        disableInputs(mobiusWrapper, false)

                        addTrackingEvent('trackMobiusForm', 'mobius-form', submitButtom.innerText)
                        //submitButtom.click();
                        resolve(true);
                    } else {
                         if (debug) console.log('error', result.status);

                        showAlert(mobiusWrapper, 'msgError')
                        enableInputs(mobiusWrapper)

                        addTrackingEvent('trackMobiusForm', 'mobius-form', submitButtom.innerText)
                        reject(false)
                    }
                })
            //resolve(true);
        });
    };
	//#region  
    const submitButtom = (mobiusWrapper.querySelectorAll('[app-mobius5-send]')[0] as HTMLButtonElement)
    submitButtom.addEventListener('click', async (event: Event) => {
        if (!isDone) {
            event.preventDefault();

            const formValues = await getFormValues(mobiusWrapper)
            const eventBtn = event.currentTarget as HTMLElement;
            addTrackingEvent('trackMobiusForm', 'mobius-form', eventBtn.innerText)
            var valid = validateForm(mobiusWrapper)
            if (!valid) {
                showAlert(mobiusWrapper, 'msgIncomplete')
                return;
            }

            // imply that message is sending by ui modifications 
            disableInputs(mobiusWrapper, true)
            showAlert(mobiusWrapper, 'msgSending')
            isDone = await sendFormResponse(event, formValues).then((data: boolean) => {
                return data;
            });
            //event.returnValue = true;
            submitButtom.click();
            //Log something to make sure it is async
            console.log("I'm the first one to get called!");
        } else {
            isDone = false;
        }
    })    
    //#endregion  
}
